import React, { useContext, useState, Fragment, useEffect } from 'react'
import { AuthContext } from '../../../App/App';
import { CloseChatContext } from './ComplateMessages'
import swal from 'sweetalert';
import axios from 'axios'


function FilterHeader() {
    const { state, dispatch } = useContext(CloseChatContext)
    const { stateAuth, dispatchAuth } = useContext(AuthContext);

    const handleFilterChange = (event) => {
        setfetch({ ...fetch, status: false, row: 0, search: '' })

        dispatch({
            type: 'FILTER',
            filter: event.target.value,
            subFilter: null,
        })

        dispatch({
            type: 'ACTIVE',
            active: null,
        })
    }

    const handleSubcategoryChange = (event, action) => {
        event.preventDefault()
        if (event.target.value != '' || state.filter != '') {
            dispatch({
                type: 'FILTER',
                filter: state.filter,
                subFilter: (state.filter == 'search') ? fetch.search : event.target.value,
            })

            dispatch({
                type: 'CHATS',
                chats: []
            })

            dispatch({
                type: 'ACTIVE',
                active: null,
            })

            dispatch({
                type: 'TRIGGER',
                trigger: { message: 'reload-chats' },
            })

            setfetch({ ...fetch, status: false, row: 0 })
        } else {
            dispatch({
                type: 'TRIGGER',
                trigger: { message: 'get-chat-category' }
            })

        }
    }

    const handleInputSearch = (event) => {
        event.preventDefault()
        setfetch({
            ...fetch,
            search: event.target.value
        })
    }

    //init user and category
    useEffect(() => {
        if (state.userCategory == null) {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-access-token': localStorage.getItem('token-helpdesk-umy')
                }
            }
            axios.get('/api/v1/helpdesk/dashboard/user-categories', config)
                .then(res => {
                    const duplicate = []
                    res.data.category.map((master) => {
                        let checkpoint = null
                        res.data.category.map((compare) => {
                            if ((master.category == compare.category) && (master.role != compare.role)) {
                                duplicate.push(master.id)
                                checkpoint = master.category
                            }
                        })
                    })
                    dispatch({
                        type: 'USER_CATEGORY',
                        userCategory: { user: res.data.client, category: res.data.category, duplicate: duplicate }
                    })
                })
                .catch(err => {
                    if (!err.response || err.code === 'ECONNABORTED') {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response) {
                        if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                            dispatchAuth({
                                type: "LOGOUT",
                                message: 'Token expired, please login again...'
                            })
                        } else {
                            swal("Error!", `${err.response.data.message}`, "error", {
                                button: "OK",
                            });
                        }
                    }
                })
        }
    }, [state.userCategory])

    const [fetch, setfetch] = useState({ status: false, row: 0, search: '' })
    const fetchMoreData = () => {
        if (fetch.status != null) {
            setfetch({ ...fetch, status: true })
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-access-token': localStorage.getItem('token-helpdesk-umy')
                }
            }
            axios.get(`/api/v1/helpdesk/${state.action}/chats/done/${state.filter}/${(state.filter == 'all') ? 'all' : state.subFilter}/${fetch.row}`, config)
                .then(res => {
                    const same = (state.action == renderCategory.tempFilter.action && state.filter == renderCategory.tempFilter.main && state.subFilter == renderCategory.tempFilter.sub) ? true : false
                    setfetch({
                        ...fetch,
                        status: res.data.data.length < 20 ? null : false,
                        row: res.data.data.length < 20 ? 0 : fetch.row + 20
                    })
                    //chek filter
                    let cleanChats = same ? state.chats.concat(res.data.data) : res.data.data
                    //duplicate
                    let duplicate = {}
                    cleanChats = cleanChats.filter(function (chat) {
                        if (chat.id in duplicate) return false
                        else {
                            duplicate[chat.id] = true
                            return true
                        }
                    })
                    //sort by time
                    cleanChats = cleanChats.sort((a, b) => b.time.localeCompare(a.time))
                    dispatch({
                        type: 'CHATS',
                        chats: cleanChats
                    })

                    setrenderCategory({
                        ...renderCategory,
                        tempFilter: same ? renderCategory.tempFilter : { action: state.action, main: state.filter, sub: state.subFilter }
                    })
                    dispatch({
                        type: 'TRIGGER',
                        trigger: { message: null },
                    })
                })
                .catch(err => {
                    setfetch({ ...fetch, status: false })
                    dispatch({
                        type: 'TRIGGER',
                        trigger: { message: null },
                    })
                    if (!err.response || err.code === 'ECONNABORTED') {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response) {
                        if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                            dispatchAuth({
                                type: "LOGOUT",
                                message: 'Token expired, please login again!!!'
                            })
                        } else if (err.response.data.message) {
                            swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                                button: "OK",
                            });
                        }
                    }
                })
        }
    }

    // reload chat
    useEffect(() => {
        if (state.trigger.message == "reload-chats") {
            fetchMoreData()
        }
    }, [state.trigger])

    const initialCategory = {
        render: (<div className="form-group col-6">
            <select name="filter" className="form-control form-select ml-0 mr-sm-2" style={{ "width": "100%" }} onChange={handleFilterChange}>
                <option value="all" defaultValue>All Message</option>
                <option value="user">User</option>
                <option value="category">Category</option>
                <option value="search">Search</option>
            </select>
        </div>),
        tempFilter: { action: state.action, main: state.filter, sub: 'all' }
    }
    const [renderCategory, setrenderCategory] = useState(initialCategory)
    useEffect(() => {
        setrenderCategory({
            ...renderCategory,
            render: (<div className="form-group col-6">
                <select name="filter" value={state.filter} className="form-control form-select ml-0 mr-sm-2" style={{ "width": "100%" }} onChange={handleFilterChange}>
                    <option value="all" >All Message</option>
                    <option value="user">User</option>
                    <option value="category">Category</option>
                    <option value="search">Search</option>
                </select>
            </div>),
        })

        setfetch({ ...fetch, status: false, row: 0, search: '' })

        if (state.filter == 'all') {
            dispatch({
                type: 'TRIGGER',
                trigger: { message: 'reload-chats' },
            })
        }
    }, [state.action, state.filter])

    const [renderSubCategory, setrenderSubCategory] = useState(<Fragment />)
    useEffect(() => {
        if (state.filter == 'all') {
            setrenderSubCategory(<Fragment />)
            dispatch({
                type: 'TRIGGER',
                trigger: { message: 'reload-chats' },
            })
        } else if (state.filter == 'user' && state.userCategory != null) {
            setrenderSubCategory(
                <div className="form-group col-6">
                    <select name="filter" className="form-control form-select ml-0 mr-sm-2" style={{ "width": "100%" }} onChange={handleSubcategoryChange}>
                        <option value="" defaultValue >Choose Sub Category</option>
                        {(state.userCategory != null) ? state.userCategory.user.map((op) => (<option key={op.role_id} value={op.role_id}>{op.client}</option>)) : ''}
                    </select>
                </div>)
            dispatch({
                type: "TRIGGER",
                trigger: { message: "get-chat-category" }
            })
        } else if (state.filter == 'category' && state.userCategory != null) {
            //find duplicate category name
            const name = (data) => {
                if (state.userCategory.duplicate.includes(data.id)) {
                    return `${data.category} (${state.userCategory.user.find(user => user.role_id == data.role).client})`
                } else {
                    return data.category
                }
            }
            setrenderSubCategory(
                <div className="form-group col-6">
                    <select name="filter" className="form-control form-select ml-0 mr-sm-2" style={{ "width": "100%" }} onChange={handleSubcategoryChange}>
                        <option value="" defaultValue >Choose Sub Category</option>
                        {(state.userCategory != null) ? state.userCategory.category.map((op) => (<option key={op.id} value={op.id}>{name(op)}</option>)) : ''}
                    </select>
                </div>)

            dispatch({
                type: "TRIGGER",
                trigger: { message: "get-chat-category" }
            })
        } else if (state.filter == 'search') {
            setrenderSubCategory(
                <form className="card-header-form  col-6">
                    <div className="input-group">
                        <input type="text" name="search" className="form-control" placeholder="Type here..." value={fetch.search} onChange={handleInputSearch} />
                        <button className="btn btn-primary btn-icon" onClick={(e) => handleSubcategoryChange(e, 'search')}><i className="fas fa-search"></i></button>
                    </div>
                </form>)

            dispatch({
                type: "TRIGGER",
                trigger: { message: "get-chat-category" }
            })
        } else {
            swal("Error!", "Check Your Internet Connection!", "error", {
                button: "OK",
            });
        }
    }, [state.filter, fetch.search])

    return (
        <div className="form-row mt-2 ml-2 p-0 col-12 ">
            <div className="form-group mt-4 mb-0 mr-0 ml-2 p-0 col-1">
                <small className="mr-0 ml-0 sm-2"><b>Filter</b></small>
            </div>
            <div className="form-group mt-2 mb-0 mr-0 ml-0 col-10">
                <div className="form-row m-0 p-1 col-12">
                    {renderCategory.render}
                    {renderSubCategory}
                </div>
            </div>
        </div>
    )
}

export default FilterHeader
